/** @format */

import React, { Component } from "react";
import {
	Container,
	Row,
	Col,
	Breadcrumb,
	BreadcrumbItem,
	Button,
	Input,
	Card,
	CardBody,
	CardHeader,
	Table,
	CardText,
} from "reactstrap";
import {
	setCookie,
	getCookie,
	eraseCookie,
	setLocalStorage,
	getLocalStorage,
} from "../global/browserFunctions";
import items from "../data/cart.json";
import Icon from "./Icon";
import { cartUrl } from "../global/url";
import { checkoutUrl } from "../global/url";
import {
	showNotification,
	noDismissNotification,
} from "../global/notification";
import jquery from "jquery";
import Loader from "../components/Loader";
import _ from "underscore";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

class CartItems extends Component {
	constructor(props) {
		super(props);
		this.state = {
			items: [],
			itemReplica: [],
			loading: false,
			subtotal: 0,
			showCheckoutbtn: false,
			stock: {},
			disableCheckoutbtn: false
		};
		this.priceLevel = "1";
		this.removeFromCart = this.removeFromCart.bind(this);
		this.decreaseQuantity = this.decreaseQuantity.bind(this);
		this.increaseQuantity = this.increaseQuantity.bind(this);
		this.fetchItems = this.fetchItems.bind(this);
		this.updateCart = this.updateCart.bind(this);
		this.moveToCheckout = this.moveToCheckout.bind(this);
		this.getAvailableQuanitiy = this.getAvailableQuanitiy.bind(this);
	}

	removeFromCart(e, item) {
		var items = [...this.state.items];
		var id = item.itemID;
		var items = _.reject(items, function (eachItem) {
			if (eachItem.itemID == id) return eachItem;
		});
		this.setState({ items: items }, function () {
			this.setSubTotal();
		});
	}

	moveToCheckout(e) {
		var query = "&apiType=verifyStock&customerId=";
		var customer = getCookie("customid");
		query += customer;
		this.setState({ loading: true });
		var self = this;
		jquery
			.ajax({
				url: checkoutUrl + query,
				Cache: false,
				dataType: "jsonp",
			})
			.done(function (data) {
				self.setState({ loading: false });
				try {
					data = JSON.parse(decodeURIComponent(data));
					if (data.summary.status == "FAILURE") {
						var items = data.data.items;
						var stockSummary = data.data.stock_summary;

						if (stockSummary.INSUFFICIENT_STOCK || stockSummary.ITEM_INACTIVE) {
							var message = "";
							for (var i in items) {
								if (!items[i].customercart__cart_item_sufficientstock.value) {
									var stockAvailable =
										parseInt(items[i].customercart__cart_item_quantity.value) +
										items[i].customercart__cart_item_remainderstock.value;
									var itemName =
										items[i].customercart__cart_item_internalid.text;
									message +=
										stockAvailable +
										" " +
										"units available for " +
										itemName +
										", ";
								}
								if (items[i].customercart__cart_item_inactive.value) {
									var itemName =
										items[i].customercart__cart_item_internalid.text;
									message += " " + itemName + " is no longer available,";
								}
							}

							noDismissNotification("Update quantity", "info", message);
						} else {
							showNotification(
								"Sorry",
								"danger",
								"An unknown error occurred. Couldn't fetch checkout info"
							);
						}
					} else {
						self.props.history.push("/checkout");
					}
				} catch (error) {
					self.setState({ loading: false });
					console.log("err@checkout", error);
					showNotification(
						"Sorry",
						"danger",
						"An unknown error occurred. Couldn't fetch checkout info"
					);
				}
			})
			.fail(function () {
				self.setState({ loading: false });
				showNotification("Sorry", "danger", "Check your network please");
			});
	}

	componentDidMount() {
		this.setState({ loading: true });
		this.setSubTotal();
		this.fetchItems();
		this.getAvailableQuanitiy()
	}
	fetchItems() {
		var query = "&method=fetch&customer=";
		var customer = getCookie("customid");
		query += customer;
		var self = this;
		jquery
			.ajax({
				url: cartUrl + query,
				Cache: false,
				dataType: "jsonp",
			})
			.done(function (data) {
				self.setState({ loading: false });
				try {
					data = JSON.parse(decodeURIComponent(data));
					console.log("data", data);
					if (data.summary && data.summary.status == "SUCCESS") {
						var items = data.summary.data || [];
						if (items.length > 0) {
							self.setState({ showCheckoutbtn: true })
						}
						for (var i in items) {
							var matrixOption = JSON.parse(items[i].metrixOption || {});
							items[i] = _.extend(items[i], matrixOption);
						}
						self.setState({ items: items });
						self.setState({ itemReplica: items }, function () {
							self.setSubTotal();
						});
					} else {
						setCookie("cartCount", 0);
					}
				} catch (error) {
					console.log("err@fectchcart", error);
				}
			})
			.fail(function () {
				self.setState({ loading: false });
				showNotification(
					"Sorry",
					"danger",
					"An unknown error occurred. Couldn't fetch cart info"
				);
			});
	}

	setSubTotal() {
		var items = [...this.state.items];
		var total = 0;
		for (var i in items) {
			var qty = parseInt(items[i].itemQuantity || 0);
			var price = items[i].pricelevelAmount;
			total = total + qty * price;
		}
		total = total.toFixed(2);
		console.log("total", total);
		this.setState({ subtotal: total });
	}
	updateCart() {
		var updateObj = {};
		var duplicateObj = [...this.state.itemReplica];
		var itemsObj = [...this.state.items];

		for (var i in duplicateObj) {
			var id = duplicateObj[i].itemID;
			console.log("id", id);
			var index = itemsObj.findIndex(
				//If using id, an item exist then find the index of the item inn array
				(x) => x.itemID == id
			);
			id = id.toString();
			if (index == -1) {
				updateObj[id] = 0;
			} else {
				updateObj[id] = itemsObj[index].itemQuantity;
			}
		}

		confirmAlert({
			title: "Update cart",
			message: "This will update your order, are you sure you want to do this?",
			buttons: [
				{
					label: "Yes",
					onClick: () => this.updateFinal(updateObj),
				},
				{
					label: "No",
				},
			],
		});
	}

	updateFinal(updateObj) {
		this.setState({ loading: true });
		var query = "&method=update&customer=";
		var customer = getCookie("customid");
		query += customer;
		updateObj = JSON.stringify(updateObj);
		query += "&items=" + updateObj;
		var self = this;
		jquery
			.ajax({
				url: cartUrl + query,
				Cache: false,
				dataType: "jsonp",
			})
			.done(function (data) {
				self.setState({ loading: false });
				try {
					data = JSON.parse(decodeURIComponent(data));
					if (data.summary && data.summary.status == "SUCCESS") {
						showNotification(
							"Success",
							"success",
							"Your cart has been updated"
						);

						setTimeout(() => {
							window.location.reload();
						}, 2500);
					}
				} catch (error) {
					console.log("err@fectchcart", error);
				}
			})
			.fail(function () {
				self.setState({ loading: false });
				showNotification(
					"Sorry",
					"danger",
					"An unknown error occurred. Couldn't fetch cart info"
				);
			});
	}

	decreaseQuantity(item) {
		var items = [...this.state.items];
		var id = item.itemID;
		var index = items.findIndex(
			//If using id, an item exist then find the index of the item inn array
			(x) => x.itemID == id
		);
		var quantity = parseInt(items[index].itemQuantity || 1);
		quantity -= 1;
		quantity = quantity == 0 ? 1 : quantity;
		items[index].itemQuantity = quantity;
		items[index].itemQuantity = quantity;

		this.setState({ items: items });
		this.setSubTotal();
	}
	increaseQuantity(item) {
		var items = [...this.state.items];
		var id = item.itemID;
		var index = items.findIndex(
			//If using id, an item exist then find the index of the item inn array
			(x) => x.itemID == id
		);
		var quantity = parseInt(items[index].itemQuantity || 1);
		quantity += 1;
		items[index].itemQuantity = quantity;
		items[index].itemQuantity = quantity;

		this.setState({ items: items });
		this.setSubTotal();
	}
//this function is to show stock available quantity before checkout in cart
	getAvailableQuanitiy(){
		var query = "&apiType=verifyStock&customerId=";
		var customer = getCookie("customid");
		query += customer;
		this.setState({ loading: true });
		var self = this;
		jquery
			.ajax({
				url: checkoutUrl + query,
				Cache: false,
				dataType: "jsonp",
			})
			.done(function (data) {
				try {
					data = JSON.parse(decodeURIComponent(data));
					var items = data.data.items;
					var stock = {};
					self.setState({ loading: false });
					items.forEach(item => {
						var itemID = parseInt(item.customercart__cart_item_internalid.value);
						stock[itemID] = item.customercart__cart_item_remainderstock.value+parseInt(item.customercart__cart_item_quantity.value);
						if(item.customercart__cart_item_quantity.value > stock[itemID]){
							self.setState({
								disableCheckoutbtn: true
							});
						}
					});
					self.setState({
						stock:{...stock}
					});
				} catch (error) {
					console.log("err@availableQuantity", error);
					showNotification(
						"Sorry",
						"danger",
						"An unknown error occurred. Couldn't fetch checkout info"
					);
				}
			})
			.fail(function () {
				showNotification("Sorry", "danger", "Check your network please");
			});
	}

	render() {
		var style1 = {fontSize:"0.8em"};
		var style2 = {color: 'red',fontSize: "0.8em"};
		return (
			<React.Fragment>
				<Loader loading={this.state.loading} />
				<Col lg='8' className='pr-xl-5'>
					<div className='cart mb-5'>
						<div className='cart-body'>
							{!this.state.showCheckoutbtn && (
								<div className='text-muted ml-3'>Your cart is empty</div>
							)}
							{this.state.items.map((item) => (
								<div key={item.itemID} className='cart-item'>
									<Row className='d-flex align-items-center text-left text-md-center'>
										<Col xs='12' md='5'>
											{/* MOBILE REMOVE FROM CART BUTTON */}
											<a
												className='cart-remove close mt-3 d-md-none'
												href='#'
												onClick={(e) => this.removeFromCart(e, item)}
											>
												<i className='fa fa-times' />
											</a>
											{/* END MOBILE REMOVE FROM CART BUTTON */}

											<div className='d-flex align-items-center'>
												{/* PRODUCT IMAGE */}
												<a href={item.link}>
													<img
														className='cart-item-img'
														src={item.imageUrl}
														alt='image'
													/>
												</a>
												{/* END PRODUCT IMAGE */}

												<div className='cart-title text-left '>
													{/* PRODUCT TITLE */}
													<a href={item.link} className='text-dark'>
														<strong>{item.name}</strong>
													</a>
													<br />
													{/* END PRODUCT TITLE */}

													{/* PRODUCT ATTRIBUTES */}
													<div className='mt-2'>
														{item.item_custitembicyclecolor.value && (
															<div>
																<span className='text-muted text-sm'>
																	Color: {item.item_custitembicyclecolor.text}
																</span>
															</div>
														)}
														{item.item_custitembicycleaccessorycolor.value && (
															<div>
																<span className='text-muted text-sm'>
																	Color:{" "}
																	{item.item_custitembicycleaccessorycolor.text}
																</span>
															</div>
														)}
														{item.item_custitembicyclesize.value && (
															<div>
																<span className='text-muted text-sm'>
																	Size: {item.item_custitembicyclesize.text}
																</span>
															</div>
														)}
														{item.item_custitembicycleaccessorysize.value && (
															<div>
																<span className='text-muted text-sm'>
																	Size:{" "}
																	{item.item_custitembicycleaccessorysize.text}
																</span>
															</div>
														)}
														{item.item_custitembicyclespeed.value && (
															<div>
																<span className='text-muted text-sm'>
																	Speed: {item.item_custitembicyclespeed.text}
																</span>
															</div>
														)}
													</div>
													{/* END PRODUCT ATTRIBUTES */}
												</div>
											</div>
										</Col>
										<Col xs='12' md='7' className='mt-4 mt-md-0'>
											<Row className='align-items-center'>
												<Col md='3'>
													{/* PRODUCT PRICE */}
													<Row>
														<Col xs='6' className='d-md-none text-muted'>
															Price per item
														</Col>
														<Col
															xs='6'
															md='12'
															className='text-right text-md-center'
														>
															${item.pricelevelAmount}
														</Col>
													</Row>
													{/* END PRODUCT PRICE */}
												</Col>
												<Col md='4'>
													<Row className='align-items-center'>
														{/* PRODUCT QUANTITY */}
														<Col xs='7' sm='9' className='text-muted d-md-none'>
															Quantity
														</Col>
														<Col xs='5' sm='3' md='12'>
															<div className='d-flex align-items-center'>
																<Button
																	color='items'
																	className='items-decrease'
																	onClick={() => this.decreaseQuantity(item)}
																>
																	-
																</Button>
																<Input
																	className='text-center border-0 border-md input-items'
																	value={item.itemQuantity}
																	type='text'
																/>
																<Button
																	disabled={item.itemQuantity >= this.state.stock[item.itemID]}
																	color='items'
																	className='items-increase'
																	onClick={() => this.increaseQuantity(item)}
																>
																	+
																</Button>
															</div>
														</Col>
														{/* END PRODUCT QUANTITY */}
													</Row>
													<Row className='align-items-center' className='available-quantity-responsive'>
														<Col xs='5' sm='3' md='12'>
															<div className='text-muted text-sm'>
																{this.state.loading
																	?<div></div>
																	:<div
																		className='mt-2'
																		style={item.itemQuantity > this.state.stock[item.itemID]
																			?style2
																			:style1}
																	>
																		{this.state.stock[item.itemID] } items available
																	</div>}
															</div>
														</Col>
													</Row>
												</Col>
												<Col md='3'>
													<Row>
														{/* PRICE TOTAL */}
														<Col xs='6' className='d-md-none text-muted'>
															Total price
														</Col>
														<Col
															xs='6'
															md='12'
															className='text-right text-md-center'
														>
															$
															{(
																item.pricelevelAmount * item.itemQuantity
															).toFixed(2)}
														</Col>
														{/* END PRICE TOTAL */}
													</Row>
												</Col>
												<Col xs='2' className='d-none d-md-block text-center'>
													{/* REMOVE FROM CART BUTTON */}
													<a
														className='cart-remove text-muted'
														onClick={(e) => this.removeFromCart(e, item)}
													>
														<Icon
															icon='close-1'
															className='w-2rem h-2rem svg-icon-light'
														/>
													</a>
													{/* END REMOVE FROM CART BUTTON */}
												</Col>
											</Row>
										</Col>
									</Row>
								</div>
							))}
						</div>
					</div>
					<div className='d-flex justify-content-between flex-column flex-lg-row mb-5 mb-lg-0'>
						<Button color='link' className='text-muted' href='/home'>
							<i className='fa fa-chevron-left' />
							Continue Shopping
						</Button>
						{this.state.showCheckoutbtn && (
							<Button
								color='link'
								className='text-primary'
								onClick={this.updateCart}
							>
								<i className='fa fa-sync' /> Update cart
							</Button>
						)}

					</div>
				</Col>
				{this.state.showCheckoutbtn && (
					<Col lg='4'>
						<Card className='mb-5'>
							<CardHeader>
								<h6 className='mb-0'>Order Summary</h6>
							</CardHeader>
							<CardBody className='py-4'>
								<p className='text-muted text-sm'>
									Shipping and additional costs are calculated on checkout
								</p>
								<CardText tag='table' className='table'>
									<tbody>
									<tr>
										<th className='py-4'>Subtotal</th>
										<td className='py-4 text-right text-muted'>
											${this.state.subtotal}
										</td>
									</tr>
									<tr>
										<th className='pt-4'>Total</th>
										<td className='pt-4 text-right h3 font-weight-normal'>
											${this.state.subtotal}
										</td>
									</tr>
									</tbody>
								</CardText>
							</CardBody>
						</Card>

						<Button disabled={this.state.disableCheckoutbtn} color='dark' block onClick={(e) => this.moveToCheckout(e)}>
							Proceed to checkout
						</Button>

					</Col>
				)}
			</React.Fragment>
		);
	}
}

export default CartItems;
